"use client";

import { type ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

type AppModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: ReactNode;
  /** Optional content between the header and footer (e.g. form fields). */
  body?: ReactNode;
  children: ReactNode;
  isDismissDisabled?: boolean;
  contentClassName?: string;
  bodyClassName?: string;
};

export function AppModal({
  isOpen,
  onClose,
  title,
  description,
  body,
  children,
  isDismissDisabled = false,
  contentClassName,
  bodyClassName,
}: AppModalProps) {
  return (
    <Dialog
      onOpenChange={(nextOpen) => {
        if (!nextOpen && !isDismissDisabled) {
          onClose();
        }
      }}
      open={isOpen}
    >
      <DialogContent
        className={contentClassName}
        showCloseButton={!isDismissDisabled}
      >
        <DialogHeader className={cn(!isDismissDisabled ? "pr-10" : null)}>
          <DialogTitle>{title}</DialogTitle>
          {description ? <DialogDescription>{description}</DialogDescription> : null}
        </DialogHeader>
        {body ? <div className={cn("grid gap-3", bodyClassName)}>{body}</div> : null}
        <DialogFooter>{children}</DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
